import React from 'react'
import {
    titleToSlug,
} from "../../../utils/generalLiveCenter";
import { DateUtility } from "../../../utils/dateUtility";
import NextImage from "../../common/NextImage";
import CricketMatchBox from './CricketMatchBox';

const CricketLeagueBox = ({ data, difference, displayDate, dictionary, baseURL, websiteBaseUrl,
    dataPath,
    dataClient, sport, tournamentListing }) => {


    const handleHeadClick = (head) => {
        if (dataClient) {
            window.location.href = websiteBaseUrl
                ? `${websiteBaseUrl}/${dataPath}/league/${titleToSlug(
                    head?.nm
                )}/${head?.id}/info`
                : `/${dataPath}/league/${titleToSlug(
                    head?.nm
                )}/${head?.id}/info`;
        }
    };

    return (<>
        {data?.map((league, index) => (
            <div className="leg_box" key={index}>

                <div className="leg_head">
                    <h2>
                        {tournamentListing !== "tournamentListing" ? (
                            <a href="#" onClick={(e) => { e.preventDefault(); handleHeadClick(league); }}>
                                <div className="icon_flag">
                                    <NextImage
                                        src={`${baseURL}/public/assets/images/flags/country_${league?.fid}.png`}
                                        height={23}
                                        width={23}
                                        alt="teamLogo"
                                        priority={false}
                                    />
                                </div>
                                <span className="name">
                                    {league?.nm}
                                </span>
                            </a>
                        ) : (
                            <span className={`name ${league?.d}`}>
                                {DateUtility.FormatDate(new Date(league?.d))}
                            </span>
                        )}
                    </h2>
                </div>
                <CricketMatchBox league={league} difference={difference} displayDate={displayDate} dictionary={dictionary} baseURL={baseURL} websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}
                    dataClient={dataClient}
                    sport={sport}

                />

            </div>
        ))}
    </>
    )
}

export default CricketLeagueBox